export default __webpack_public_path__ + "static/media/Gen_terms_3_3_21.811eb418.pdf";